var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircleBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.269 2 2 8.269 2 16s6.269 14 14 14 14-6.269 14-14S23.731 2 16 2zm0 22.125a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm1.966-6.86a1.509 1.509 0 0 0-.966 1.4v.71a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-.672c0-.722.21-1.434.622-2.028a3.492 3.492 0 0 1 1.628-1.278c1.063-.41 1.75-1.3 1.75-2.272 0-1.378-1.347-2.5-3-2.5s-3 1.122-3 2.5v.238a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-.238c0-1.228.537-2.375 1.512-3.228.938-.822 2.175-1.272 3.488-1.272 1.313 0 2.55.453 3.488 1.272.974.853 1.512 2 1.512 3.228 0 1.806-1.19 3.431-3.034 4.14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircleBold);
export default __webpack_public_path__ + "static/media/question-circle-bold.3fd5b57bfbd6e38ab22367ccdfa78146.svg";
export { ForwardRef as ReactComponent };